import { arrayEquals } from './util';
export class SyncDescriptor {
    constructor(ctor, staticArguments = [], supportsDelayedInstantiation = false, supportsOverride = false) {
        this.ctor = ctor;
        this.staticArguments = staticArguments;
        this.supportsDelayedInstantiation = supportsDelayedInstantiation;
        this.supportsOverride = supportsOverride;
    }
    isEqualWith(descriptor) {
        if (this.ctor !== descriptor.ctor) {
            return false;
        }
        if (this.supportsDelayedInstantiation !== descriptor.supportsDelayedInstantiation) {
            return false;
        }
        if (this.supportsOverride !== descriptor.supportsOverride) {
            return false;
        }
        if (!arrayEquals(this.staticArguments, descriptor.staticArguments)) {
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=descriptors.js.map